export default __webpack_public_path__ + "static/media/despre-dimi-home.03db83a6.webp";